import script from "./ow-users-form.vue?vue&type=script&setup=true&lang=js"
export * from "./ow-users-form.vue?vue&type=script&setup=true&lang=js"

import "./ow-users-form.vue?vue&type=style&index=0&id=03b2655d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-03b2655d"]])

export default __exports__